<template>
  <section class="page page-products" v-if="pageIsReady">
    <section
      class="stock-page-container"
      v-if="page.products && page.products.length"
    >
      <Product
        v-for="(item, itemIndex) in page.products"
        :key="itemIndex"
        :originalProduct="item"
        :withDescription="true"
        :pageType="'stock'"
        :withProductGrid="true"
        :withImage="true"
        :pageId="pageId"
        :columnIndex="itemIndex"
        :itemIndex="itemIndex"
        :itemsCount="page.products.length"
        :readOnly="readOnly"
        :productIsCustomizable="true"
        @openSearchModal="(pr) => emitOpenSearchModal(pr)"
      />
    </section>
    <section class="stock-page-container stock-page-container-missing" v-else>
      <MissingProduct />
    </section>
    <section
      class="page-number-count"
      :class="{ 'right-page-number': pageId % 2 === 0 }"
    >
      {{ pageId }}
    </section>
  </section>
</template>

<script>
import Product from "@/components/Projects/Product/Product.vue";
import MissingProduct from "@/components/Projects/Playbooks/MissingProduct.vue";

export default {
  name: "StockPage",

  props: {
    page: {
      type: Object,
    },
    readOnly: {
      type: Boolean,
    },
    pageId: {
      type: Number,
    },
    anonymousCrossOrigin: {
      type: Boolean,
    },
  },

  components: {
    Product,
    MissingProduct,
  },

  computed: {
    products() {
      return this.page.products;
    },
  },

  methods: {
    emitOpenSearchModal(pr) {
      console.log({ pr });
      this.$emit("openSearchModal", pr);
    },
  },

  mounted() {
    //make a loader for sidebar, which is when this is read only
    const delay = this.pageId || 1
    if (!this.pageIsReady) {
      setTimeout(() => {
        this.pageIsReady = true
      }, 1500 * delay);
    }
  },

  data() {
    return {
      pageIsReady: !this.readOnly
    }
  }
};
</script>

<style lang="scss">
#app {
  .page-products {
    .stock-page-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 1em;
      grid-template-rows: repeat(2, 50%);
      height: 100%;
      padding: 1em 1.5em;

      .product {
        justify-content: space-between;

        .product-preview {
          height: 60% !important;
        }

        .product-info {
          margin-bottom: 0;
        }
      }

      .grid-title-container {
        padding: 0 0.75em !important;
      }
    }
  }
}
</style>
